import type { msgDialogPropsParams } from "@/types/components/DMODU_CONTROLE/msgDialog.types";
import type { ModuControleDialogs } from "@r3shared/types/WMS/MODU_CONTROLE/events/events.types";
import { R3EventEmitter } from "../../../r3utils/src/events/emitter";
//import type { ModuControleDialogs } from "@r3shared/";
//import { R3EventEmitter } from "@r3utils";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  const eventEmitter = new R3EventEmitter<
    ModuControleDialogs,
    msgDialogPropsParams
  >(["MsgDlg"]);
  // const logFilePath = nodePath.join(config.public.MODU_CONTROLE_LOG_PATH);
  // console.log('logFilePath', logFilePath);
  return {
    provide: {
      r3ModuControleEvents: eventEmitter,
    },
  };
});
